<template>
    <div v-cloak class="home">
        <div class="swiper">
          <div>
            <img src="../assets/banner2.jpg" width="100%">
          </div>
        </div>

        <div class="content">
            <van-row class="row" type="flex" justify="space-between">
                <van-col span="8">
                    <router-link :to="{ name: 'Rquipment'}">
                        <img src="../assets/icon_shebeiguanli@2x.png" alt="设备">
                        <p>设备管理</p>
                    </router-link>
                </van-col>
                <van-col span="8">
                    <router-link :to="{ name: 'User'}">
                        <img src="../assets/icon_gerenzhongxin@2x.png" alt="设备">
                        <p>个人中心</p>
                    </router-link>
                </van-col>
                <van-col span="8">
                    <router-link :to="{ name: 'UserInformation'}">
                        <img src="../assets/icon_shiyongrenxinxi@2x.png" alt="设备">
                        <p>使用人信息</p>
                    </router-link>
                </van-col>
            </van-row>
            <van-row type="flex" justify="space-between">
                <van-col span="8">
                    <router-link :to="{ name: 'ThreeServices'}">
                        <img src="../assets/icon_sandafuwu@2x.png" alt="设备">
                        <p>三大服务</p>
                    </router-link>
                </van-col>
                <van-col span="8">
                    <router-link :to="{ name: 'Integral'}">
                        <img src="../assets/icon_jifenguanli@2x.png" alt="设备">
                        <p>积分管理</p>
                    </router-link>
                </van-col>
                <van-col span="8">
                    <router-link :to="{ name: 'AfterSale'}">
                        <img src="../assets/icon_shouhoufuwu@2x.png" alt="设备">
                        <p>售后服务</p>
                    </router-link>
                </van-col>
            </van-row>
          <a id="ids" href="https://beian.miit.gov.cn/" target="_blank">京ICP备15041006号-2</a>
        </div>

        <footer class="footer">
            <ul>
                <li>
                    <img src="../assets/icon_home@2x.png" alt="首页图标">
                    <p>首页</p>
                </li>
                <li>
                    <router-link :to="{name: 'VisionReport'}">
                        <img src="../assets/icon_shilibaogao @2x.png" alt="视力报告">
                        <p>视力报告</p>
                    </router-link>
                </li>
                <li>
                    <router-link :to="{name: 'ShoppingMall'}">
                        <img src="../assets/icon@2x.png" alt="商城图标">
                        <p>商城</p>
                    </router-link>
                </li>
            </ul>
        </footer>
    </div>
</template>

<script>
import Vue from 'vue';
import { Image } from 'vant';

Vue.use(Image);

export default {
    data() {
        return {
            code: this.getQueryString("code"),
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        getQueryString: function (name) {
            const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
            const r = window.location.search.substr(1).match(reg);//search,查询？后面的参数，并匹配正则
            if (r != null) return unescape(r[2]);
            return null;
        },
        getData() {
            console.log(this.code)
            this.axios.get('/weixin/toFirstPage',{
                params: {
                    code: this.code
                }
            }).then((response)=>{
                console.log(response.data)
            }).catch((response)=>{
                console.log(response)
            })
        },

    },
}
</script>

<style scoped>
.swiper {
    overflow: hidden;
    height: 0;
    width: 100%;
    padding-bottom: 46%;

}
.home {
    background-color: #f8f8f8;
    height: 100%;
}
.van-swipe {
    height: 390px;
}
.van-swipe__indicators {
    margin-bottom: 34px;
}
.van-swipe__indicator {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    margin-right: 30px;
    background-color: #d2d2d4;
}
.van-swipe__indicator--active{
    background-color: #fff;
}

.content {
    height: 70%;
    margin: 30px 0 0 0;
    padding: 70px 90px 0;
    text-align: center;
    background: #ffffff;
    font-size: 38px;
}
.content p {
    margin: 36px 0 60px;
}
#ids {
  position:fixed;
  margin:auto;
  left:0;
  right:0;
  width:50%;
  bottom:180px;
}
.content img {
    width: 142px;
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue